module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    }
  }, [_vm._m(0), _vm._v(" "), _c('h2', [_vm._v("Personalised help.")]), _vm._v(" "), _c('p', [_vm._v("Our experts are going to contact you for a visa appeal personalised procedure.")]), _vm._v(" "), _c('p', [_vm._v("\n  If you have some questions you can contact us by email "), _c('a', {
    on: {
      "click": function($event) {
        return _vm.onClickContact()
      }
    }
  }, [_vm._v("contact-visa@getmyvisatofrance.com")]), _vm._v(". \n  ")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "centered-child",
    staticStyle: {
      "padding-bottom": "16px"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "max-width": "200px"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/team.svg",
      "width": "100%"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f221d5dc","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/screens/ScreenWeContactYou.vue
// module id = 746
// module chunks = 3